import type { TFunction } from 'i18next';
import { SupportedProductType } from '@/types/api';

/**
 * Product-type labels for the request overview. The audience here is a
 * specialist, so a few products use insurance terminology that differs from the
 * customer-facing wording in `productPackage.products.*` — everything without an
 * override falls back to that shared label.
 */
const SPECIALIST_LABEL_KEYS: Partial<Record<string, string>> = {
	[SupportedProductType.SICK_LEAVE_SHORT_TERM]:
		'requestOverview.quotes.productLabels.sickLeaveShortTerm'
};

const CUSTOMER_LABEL_KEYS: Record<string, string> = {
	[SupportedProductType.SICK_LEAVE_SHORT_TERM]: 'productPackage.products.sickLeaveShortTerm',
	[SupportedProductType.OCCUPATIONAL_HEALTH_SERVICE]:
		'productPackage.products.occupationalHealthService',
	[SupportedProductType.SICK_LEAVE_LONG_TERM_WGA_GAP_EXTENDED]:
		'productPackage.products.wgaGapExtended',
	[SupportedProductType.SICK_LEAVE_LONG_TERM_WGA_GAP]: 'productPackage.products.wgaGap',
	[SupportedProductType.SICK_LEAVE_LONG_TERM_WIA_EXCESS]: 'productPackage.products.wiaExcess'
};

/**
 * Label for one product type on the request overview. Shared by the quote
 * carousels and the package overview so the two can never disagree.
 */
export const getProductLabel = (t: TFunction, productType: string): string => {
	const key = SPECIALIST_LABEL_KEYS[productType] ?? CUSTOMER_LABEL_KEYS[productType];
	return key ? t(key) : productType;
};
